import { useRoutes } from "react-router-dom";
import PaymentPage from "pages/PaymentPage";

function Router() {
  return useRoutes([
    {
      path: "/:paymentCode",
      element: <PaymentPage />,
    },
    {
      path: "*",
      element: <p>Page not found</p>,
    },
  ]);
}

export default Router;
